import CloseIssueForm from './CloseIssueForm';

export default CloseIssueForm;
